document.addEventListener("DOMContentLoaded", () => {
const bodyWidth = document.body.clientWidth;
if (bodyWidth > 1367) {
    $.scrollify({
      section : ".animation",           
      easing: "swing",   
      scrollbars: true,         
      updateHash:false,
      standardScrollElements: ".counter_case",
      scrollSpeed: 2000,
      offset: 0
    });
}
});

if (window.innerWidth >= 1367) {
    function animationfas() {
        var animations = document.querySelectorAll(".fasfil-butane .animation");
        for (var i = 0; i < animations.length; i++) {
            var windowHeight = window.innerHeight;
            var elementTop = animations[i].getBoundingClientRect().top;
            var elementVisible = 100;

            if (elementTop < windowHeight - elementVisible) {
                animations[i].classList.add("active");
            } else {
                animations[i].classList.remove("active");
            }
        }
    }
    window.addEventListener("scroll", animationfas); 
    function animationfasParents() {
        var animations = document.querySelectorAll(".animationfasParents");
        for (var i = 0; i < animations.length; i++) {
            var windowHeight = window.innerHeight;
            var elementTop = animations[i].getBoundingClientRect().top;
            var elementVisible = 100;

            if (elementTop < windowHeight - elementVisible) {
                animations[i].classList.add("activeParents");
            } else {
                animations[i].classList.remove("activeParents");
            }
        }
    }
    window.addEventListener("scroll", animationfasParents); 

   

   
const banners = document.querySelectorAll('.fasfil_banner, .first-banner, .section-banner, .refule_lighter, .refule_adapters');
function setBannerHeight() {
banners.forEach(banner => {
  const contentHeight = banner.scrollHeight;
  banner.style.height = `${contentHeight}px`;
});
}

setBannerHeight();

window.addEventListener('resize', setBannerHeight);
}

window.addEventListener('scroll', function () {
    const pinTop = document.querySelector('.pin_topsec_fasfil');

    const firstBanner = document.querySelector('.fasfil_banner_1 + .first-banner_2');
 
    const secondBanner = document.querySelector('.fasfil_banner_1 + .first-banner_2 + .section-banner_1');
    const refuleLighter = document.querySelector('.refule_lighter_1');

    if (firstBanner && firstBanner.classList.contains('activeParents')) {
        pinTop.classList.add('second-active');
        pinTop.classList.remove('first-animi');
    } else {
        pinTop.classList.remove('second-active');
        pinTop.classList.add('first-animi');
    }

    if (secondBanner && secondBanner.classList.contains('activeParents')) {
        pinTop.classList.add('third-active');
    } else {
        pinTop.classList.remove('third-active');
    }   

    if (refuleLighter && refuleLighter.classList.contains('activeParents')) {
        pinTop.classList.add('hide-pin-section');
    } else {
        pinTop.classList.remove('hide-pin-section');
    }
});